import axios from '@/plugins/axios'

export const rules = {
  name: [{ required: true, trigger: 'blur', message: 'Nombre es obligatorio' }],
  type: [{ required: true, trigger: 'blur', message: 'Tipo es obligatorio' }],
  address: [{ required: true, trigger: 'blur', message: 'Tipo es obligatorio' }],

  keyword: [
    { required: true, trigger: 'blur', message: 'Escribe algo para buscar' },
    {
      min: 3,
      trigger: 'change',
      message: 'Escribe mínimo 3 carácteres'
    }
  ]
}

export const placeTypes = [
  { value: 'hotel', label: 'Hotel' },
  { value: 'airport', label: 'Aeropuerto' },
  { value: 'port', label: 'Puerto' },
  { value: 'station', label: 'Terminal' },
  { value: 'location', label: 'Locación / Punto de Encuentro' },
  { value: 'neighborhood', label: 'Barrio' },
  { value: 'city', label: 'Ciudad' },
  { value: 'state', label: 'Estado' },
  { value: 'country', label: 'País' },
  { value: 'cologne', label: 'Colonia' },
  { value: 'point-of-interest', label: 'Punto de Interés' },
  { value: 'region', label: 'Región' },
  { value: 'region', label: 'Región' },
  { value: 'ski-resort', label: 'Ski Resort' },
  { value: 'tourist-area', label: 'Area turística' },
  { value: 'accommodation', label: 'Acomodación' },
  { value: 'other', label: 'Otro' },

]

export const placeTypesStrings = {
  hotel: 'Hotel',
  airport: 'Aeropuerto',
  port: 'Puerto',
  station: 'Terminal',
  location: 'Punto de Encuentro',
  neighborhood: 'Barrio',
  city: 'Ciudad',
  state: 'Estado',
  country: 'País',
  cologne: 'Colonia',
  "point-of-interest": "Punto de Interés",
  region: 'Región',
  "ski-resort": "Ski Resort",
  "tourist-area": "Area turística",
  accommodation: 'Acomodación',
  other: 'Otro'
}

export const fetch = async (page = 1, limit = 50) => {
  try {
    const { data } = await axios.get(`/api/place?page=${page}&perPage=${limit}`)
    // TODO: Aqui debo manejar el paginador
    return data
  } catch (e) {
    return { error: true }
  }
}

export const fetchOne = async (id) => {
  try {
    const { data } = await axios.get(`/api/place/${id}`)
    return data
  } catch (e) {
    return { error: true }
  }
}

export const create = async (body) => {
  try {
    const { data } = await axios.post(`/api/place/`, body)
    return data
  } catch (e) {
    return { error: true }
  }
}

export const update = async (id, body) => {
  try {
    const { data } = await axios.put(`/api/place/${id}`, body)
    return data
  } catch (e) {
    return { error: true }
  }
}

export const toggleStatus = async (place) => {
  try {
    const active = !place.active
    const { data } = await axios.put(`/api/place/${place._id}`, { active })
    return data
  } catch (e) {
    return { error: true }
  }
}

export const autocomplete = async (keyword, placeType = '', limit = 50, parent = "", url='', transport = null) => {
  try {
    let query = url ? url : '/api/place/autocomplete'
    if (placeType.length) {
      query += `?type=${placeType}`
    }
    
    const body = { keyword, limit }
    if (parent.length) { body.parent = parent }
    const { data } = await axios.post(query, body)

    if (typeof transport === 'function') { 
      console.log('aqui')
      return transport(data)
    }

    return data
  } catch (e) {
    return { error: true }
  }
}

export const getByIds = async (ids = []) => {
  try {
    const { data } = await axios.post(`/api/place/get-by-ids`, { ids })
    return data
  } catch (e) {
    return { error: true }
  }
}